var cov_13kab1ua38 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Tabs/Link.tsx",
      hash = "016ed2fc0ab47d34b7cd68b3e50fa8d4120222d1",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Tabs/Link.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 52
        },
        end: {
          line: 11,
          column: 62
        }
      },
      "1": {
        start: {
          line: 12,
          column: 23
        },
        end: {
          line: 12,
          column: 63
        }
      },
      "2": {
        start: {
          line: 14,
          column: 18
        },
        end: {
          line: 18,
          column: 5
        }
      },
      "3": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 30,
          column: 5
        }
      },
      "4": {
        start: {
          line: 21,
          column: 6
        },
        end: {
          line: 28,
          column: 7
        }
      },
      "5": {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 27,
          column: 9
        }
      },
      "6": {
        start: {
          line: 23,
          column: 10
        },
        end: {
          line: 23,
          column: 34
        }
      },
      "7": {
        start: {
          line: 24,
          column: 10
        },
        end: {
          line: 26,
          column: 11
        }
      },
      "8": {
        start: {
          line: 25,
          column: 12
        },
        end: {
          line: 25,
          column: 27
        }
      },
      "9": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 29,
          column: 55
        }
      },
      "10": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 39
        }
      },
      "11": {
        start: {
          line: 36,
          column: 0
        },
        end: {
          line: 36,
          column: 21
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 3
          }
        },
        loc: {
          start: {
            line: 10,
            column: 11
          },
          end: {
            line: 33,
            column: 3
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 22,
            column: 24
          },
          end: {
            line: 22,
            column: 25
          }
        },
        loc: {
          start: {
            line: 22,
            column: 30
          },
          end: {
            line: 27,
            column: 9
          }
        },
        line: 22
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 30,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 30,
            column: 5
          }
        }, {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 30,
            column: 5
          }
        }],
        line: 20
      },
      "1": {
        loc: {
          start: {
            line: 21,
            column: 6
          },
          end: {
            line: 28,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 21,
            column: 6
          },
          end: {
            line: 28,
            column: 7
          }
        }, {
          start: {
            line: 21,
            column: 6
          },
          end: {
            line: 28,
            column: 7
          }
        }],
        line: 21
      },
      "2": {
        loc: {
          start: {
            line: 24,
            column: 10
          },
          end: {
            line: 26,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 24,
            column: 10
          },
          end: {
            line: 26,
            column: 11
          }
        }, {
          start: {
            line: 24,
            column: 10
          },
          end: {
            line: 26,
            column: 11
          }
        }],
        line: 24
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Tabs/Link.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { tabsClass } from './styles';
import { isLink } from '../utils/is';

var Link =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Link, _PureComponent);

  var _super = _createSuper2(Link);

  function Link() {
    _classCallCheck(this, Link);

    return _super.apply(this, arguments);
  }

  _createClass(Link, [{
    key: "render",
    value: function render() {
      cov_13kab1ua38.f[0]++;

      var _ref = (cov_13kab1ua38.s[0]++, this.props),
          children = _ref.children,
          href = _ref.href,
          className = _ref.className,
          other = _objectWithoutProperties(_ref, ["children", "href", "className"]);

      var mergeClass = (cov_13kab1ua38.s[1]++, classnames(className, tabsClass('link')));
      var props = (cov_13kab1ua38.s[2]++, _objectSpread2({
        className: mergeClass,
        href: href
      }, other));
      cov_13kab1ua38.s[3]++;

      if (isLink(children)) {
        cov_13kab1ua38.b[0][0]++;
        cov_13kab1ua38.s[4]++;

        if (children.props.onClick) {
          cov_13kab1ua38.b[1][0]++;
          cov_13kab1ua38.s[5]++;

          props.onClick = function () {
            cov_13kab1ua38.f[1]++;
            cov_13kab1ua38.s[6]++;
            children.props.onClick();
            cov_13kab1ua38.s[7]++;

            if (other.onClick) {
              cov_13kab1ua38.b[2][0]++;
              cov_13kab1ua38.s[8]++;
              other.onClick();
            } else {
              cov_13kab1ua38.b[2][1]++;
            }
          };
        } else {
          cov_13kab1ua38.b[1][1]++;
        }

        cov_13kab1ua38.s[9]++;
        return (
          /*#__PURE__*/
          React.cloneElement(children, _objectSpread2({}, props))
        );
      } else {
        cov_13kab1ua38.b[0][1]++;
      }

      cov_13kab1ua38.s[10]++;
      return (
        /*#__PURE__*/
        React.createElement("a", Object.assign({}, props, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 32,
            columnNumber: 12
          }
        }), children)
      );
    }
  }]);

  return Link;
}(PureComponent);

Link.isTabLink = void 0;
cov_13kab1ua38.s[11]++;
Link.isTabLink = true;
export default Link;